/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CircleArrow = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 27 27" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M13.5 0A13.5 13.5 0 1 0 27 13.5 13.49 13.49 0 0 0 13.5 0zm0 20.76a7.08 7.08 0 0 1-7-7.22 7.07 7.07 0 0 1 7-7.21 7.72 7.72 0 0 1 4.84 1.72V6.9a.91.91 0 0 1 .9-.9.8.8 0 0 1 .82.9v4.27h-4.1a.91.91 0 0 1 0-1.81h1a5.59 5.59 0 0 0-3.44-1.15 5.24 5.24 0 0 0-5.22 5.33 5.15 5.15 0 0 0 10.25.93h1.83a7 7 0 0 1-6.91 6.29z" />
      </g>
    </svg>
  </span>
);

CircleArrow.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CircleArrow.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CircleArrow;
